


















import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

/**
 *  Used to wrap multiple tiles in a block.
 */
@Component
export default class TileWrapper extends Vue {

    @Prop({ type: Boolean })
    private loading!: boolean;

    @Prop({ type: Boolean })
    private warning!: boolean;

}
